import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import styles from '../styles/outrun.module.scss';
import Image from 'next/image';
import ContactUsModal from '../components/contactUsModal';
import OrchestrationEn from '../public/outrun_cloud/orchestration_en.svg';
import OrchestrationRu from '../public/outrun_cloud/orchestration_ru.svg';
import OutrunPossibilities from '../components/outrunPossibilities';
import RelatedServices from "../components/relatedServices";
import OutrunService from '../public/outrun_.svg'

export default function OutRun() {
    const router = useRouter();
    const { t } = useTranslation('outrun');

    const relatedServices = [
        {
            title: 'Outrun Service',
            img: OutrunService,
            link: '/outrun-service'
        },
    ];

    return (
        <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
            <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
            <InfoSection
                title='Outrun Cloud'
                description='outrunSubtitle'
                documentationLink='https://help.icdc.io/outrun-cloud/'
                lang={router.locale}
            />

            <section className={styles.succcess}>
                <h2>{t('success.title')}</h2>
                <p>{t('success.description1')}</p>
                <p>{t('success.description2')}</p>
            </section>

            <section>
                <Image src={router.locale === 'en' ? OrchestrationEn : OrchestrationRu} alt='Orchestration' layout='responsive' />
            </section>

            <section className={styles.features}>
                <h2>{t('features.title')}</h2>
                <div className={styles.features__grid}>
                    {new Array(6).fill('').map((_, index) => (
                        <div key={index} className={styles.features__item}>
                            <Image width={24} height={24} src={`/../outrun_cloud/feature_${index + 1}.svg`} alt="" />
                            <h3>{t(`features.title${index + 1}`)}</h3>
                            <p>{t(`features.description${index + 1}`)}</p>
                        </div>
                    ))}
                </div>
            </section>

            <OutrunPossibilities />

            <section className={styles.benefits}>
                <h2>{t('benefits.title')}</h2>
                <div className={styles.benefits__content}>
                    {
                        new Array(5).fill('').map((_, key) => <div key={key} className={styles.benefits__item}>
                            <Image width={24} height={24} src={`/../outrun_cloud/benefit_${key + 1}.svg`} alt="" />
                            <p>{t(`benefits.item${key + 1}`)}</p>
                        </div>)
                    }
                </div>
            </section>

            <section className={styles.questions}>
                <h2>{t('questions.title')}</h2>
                <div className={styles.questions__content}>
                    <div className={styles.questions__item}>
                        <h3>{t('questions.card1_title')}</h3>
                        <p>{t('questions.card1_desc')}</p>
                        <div>
                            <ContactUsModal lang={router.locale} blue />
                        </div>
                    </div>
                    <div className={styles.questions__item}>
                        <h3>{t('questions.card2_title')}</h3>
                        <p className={styles['max-width']}>{t('questions.card2_desc')}</p>
                        <a href={`https://help.icdc.io/outrun-cloud/${router.locale}/Welcome.html`}>
                            <button className='btn cloud'>{t('documentation')}</button>
                        </a>
                    </div>
                </div>
            </section>

            <section>
                <RelatedServices services={relatedServices} />
            </section>

        </Layout>
    );
};

export const getStaticProps = async ({ locale }) => ({
    props: {
        ...await serverSideTranslations(locale, ['outrun', 'common']),
    },
});
